import { Component, OnInit, Input, OnChanges } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { UserService } from "../../_services/user.service";
import { RegistrationValidator } from "../../_services/custom.validation";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { CommonService } from "../../_services/common.service";
@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"]
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;

  constructor(
    private userService: UserService,
    private router: Router,
    private formBuilder: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    private CommonService: CommonService,
  ) {
    this.resetPasswordForm = formBuilder.group(
      {
        current_password: ["", [Validators.required,Validators.minLength(8)]],
        new_password: ["", [Validators.required,Validators.minLength(8)]],
        retype_new_password: ["", Validators.required]
      },
      {
        validator: RegistrationValidator.validate.bind(this)
      }
    );
  }

  isFieldValid(field: string) {
    return (
      !this.resetPasswordForm.get(field).valid &&
      this.resetPasswordForm.get(field).touched && !this.resetPasswordForm.get(field).errors.minlength
    );
  }

  displayFieldCss(field: string) {
    return {
      "has-error": this.isFieldValid(field),
      "has-feedback": this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  OnSubmit = function (post) {
    if (this.resetPasswordForm.valid) {
      let resetPassword = {
        id: localStorage.getItem("userID"),
        password: post.current_password,
        new_password: post.new_password,
        confirm_password: post.retype_new_password
      };

      this.CommonService.apiService(
        "POST",
        "password/change",
        resetPassword
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this._flashMessagesService.show(response.message, {
              cssClass: "alert-success",
              timeout: 5000
            });
            //window.scrollTo(0, 0);
            //localStorage.setItem("userDetails", JSON.stringify(response.data));
            setTimeout( this.logout(),10000);           
          }
        },
        err => {
          console.log(err);
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });

        }
      );
    } else {
      this.validateAllFormFields(this.resetPasswordForm);
    }
  }

  ngOnInit() { }

  logout(){
    localStorage.removeItem('userID');
    localStorage.removeItem('userDetails');
    window.location.href = '/';
    // this.router.navigateByUrl('/login');
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/reset-password/reset-password.component.ts